// extracted by css-extract-rspack-plugin
export default {"botCard":"botCard-WXre16","photo":"photo-VzsdKQ","content":"content-SVzA5w"};